var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 21.381,
    viewBox: "0 0 15.5 21.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1366.568 -575.475)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1372.788,585.524l-1.76-1.732-1.062,1.039,2.823,2.761,5.653-5.53-1.055-1.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1374.4,575.475h-.153a7.687,7.687,0,0,0-7.676,7.579c0,5.315,6.9,12.879,7.193,13.2l.557.6.557-.6a44.583,44.583,0,0,0,3.719-4.735c2.273-3.353,3.474-6.282,3.474-8.469A7.683,7.683,0,0,0,1374.4,575.475Zm3.791,13.948a43.278,43.278,0,0,1-3.679,5.01l-.191.223-.19-.223a41.645,41.645,0,0,1-3.839-5.3c-1.474-2.462-2.221-4.508-2.221-6.081a6.2,6.2,0,0,1,6.191-6.119h.119a6.2,6.2,0,0,1,6.19,6.116C1380.568,584.716,1379.768,586.859,1378.188,589.423Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.27ae85ea656a2ca1afabd7e15c30c034.svg";
export { ForwardRef as ReactComponent };